module.exports = __webpack_public_path__ + "img/AT0000052383153.eb06979a.png";